export const areas = [
  // ---------------- القاهرة ----------------
  // الأساس
"القاهرة",
"المقطم",
"مصر الجديده",
"العاشر من رمضان",
"بدر",
"عين شمس",
"جسر السويس",
"حلمية الزيتون",
"شيراتون مصر الجديدة",
"المطار",
"طريق الاسماعيليه",
"طريق السويس",
"الشروق",
"مدينتي",
"الرحاب",
"مدينه المستقبل",
"القطاميه",
"التجمع الخامس مدينة نصر",
"التجمع التالت",
"التجمع الاول مدينة نصر",
"شارع التسعين",
"طريق السخنه",
"الدائري",
"صلاح سالم",
"طريق الاوتوستراد مدينة المعادي",
"صقر قريش مدينة المعادي",
"المعادي",
"زهراء المعادي مدينة المعادي",
"غمره",
"احمد سعيد",
"الضاهر",
"باب الشعرية",
"الزاويه",
"السيده زينب",
"السيده عائشه",
"القلعه",
"مدينة نصر",
"مكرم عبيد مدينة نصر",
"عباس العقاد مدينة نصر",
"الحي السادس مدينة نصر",
"الحي السابع مدينة نصر",
"الحي العاشر",
"طريق المشير",
"محور جيهان السادات",
"محور محمد نجيب",
"جمال عبدالناصر",
"محور ٣٠ يونيو",
"الهضبه الوسطى",
"كورنيش المقطم",
"وسط البلد",
"حدائق القبة",
"الوايلي",
"الزيتون",
"المطرية",
"المرج",
"السلام",
"الخصوص",
"المطرية الجديدة",
"عين حلوان",
"حلوان",
"كوتسيكا",
"طرة",
"المعصرة",
"دار السلام",
"البساتين",
"منشية ناصر",
"العباسية",
"مدينة العباسية",
"حدائق الزيتون",
"الزهراء",
"مدينة الشروق",
"الهايكستب",
"الماظة",
"النزهة مصر الجديدة",
"النزهة الجديدة",
"هليوبوليس",
"سانت فاتيما مصر الجديدة",
"ميدان سانت فاتيما مصر الجديدة",
"روكسي مصر الجديدة",
"الكوربة",
"الميرغني مصر الجديدة",
"المطار القديم",
"أرض الجولف",
"الحلمية",
"سراي القبة",
"قصر القبة",
"منشية البكري",
"عين شمس الشرقية",
"عين شمس الغربية",
"شبرا",
"شبرا مصر",
"روض الفرج",
"الخليفة المأمون",
"كلية البنات مصر الجديدة",
"جامعة عين شمس",
"حدائق شبرا",
"الموسكي",
"العتبة",
"الأزبكية",
"رمسيس",
"محطة مصر",
"الفجالة",
"سكة الوايلي",
"التحرير",
"عبد المنعم رياض",
"طلعت حرب",
"قصر النيل",
"جاردن سيتي",
"ماسبيرو",
"كورنيش النيل",
"مدينة بدر",
"العاصمة الإدارية الجديدة",
"الأسمرات",
"مدينة 15 مايو",
"حلوان الجديدة",
"حدائق حلوان",
"وادي حوف",
"المعادي الجديدة مدينة المعادي",
"المعادي هايتس",
"جراند مول المعادي",
"مدينة الأمل",
"الزهراء المعادي مدينة المعادي",
"النصر سيتي سنتر",
"التجمع الثاني",
"التجمع الرابع",
"المستثمرين الشمالية",
"المستثمرين الجنوبية",
"الحرفيين",
"مسطرد",
"الشرابيه",
  // كمبوندات
"كمبوند القطامية هايتس",
"كمبوند ستون بارك",
"كمبوند ليان",
"كمبوند ميفيدا",
"كمبوند هايد بارك",
"كمبوند ماونتن فيو",
"كمبوند بالم هيلز القاهرة الجديدة",

  // شوارع رئيسية مشهورة
"شارع رمسيس",
"شارع 26 يوليو",
"شارع التحرير مدينة الجيزة",
"طلعت حرب",
"قصر العيني",
"المعز لدين الله الفاطمي",
"الحسين",
"الأزهر",
"شارع النصر مدينة نصر",
"شارع الطيران",
"شارع يوسف عباس",
"شارع مصطفى النحاس مدينة نصر",
"شارع حسن المأمون مدينة نصر",
"شارع الخليفة المأمون",
"مصطفى النحاس مدينة نصر",
"حسن المأمون مدينة نصر",
"ذاكر حسين مدينة نصر",
"شينزو آبي مدينة نصر",
"البطراوي مدينة نصر",
"شارع مصر والسودان",
"شارع شبرا",
"شارع الساحل",
"شارع بورسعيد",
"كورنيش المعادي مدينة المعادي",
"كورنيش حلوان",
"شارع 9  مدينة المعادي",
"شارع 9 المعادي",
"شارع الجامعة الأمريكية",
"شارع التسعين الشمالي",
"شارع التسعين الجنوبي",
"شارع الثورة مصر الجديدة",
"شارع العروبة",
"شارع النزهة مصر الجديدة",
"شارع عثمان بن عفان",
"شارع بيروت",
"شارع بغداد",
"شارع هارون الرشيد مصر الجديدة",
"شارع الحجاز مصر الجديدة",
"شارع عمر بن الخطاب",
"شارع جسر السويس",
"المفارق",
"شارع ٩",
"شارع صبحي حسين",
"ميدان النافورة",
"ابتاون كايرو",
"كريم بنونه",
"شارع ١٧",
"الهضبه العليا",
"الهضبه السفلى",
"كوبري حسبالله الكفراوي",
"الاسمرات",
"محور كمال عامر",
"محور عمرو بن العاص",
"امتداد رمسيس",
"الدراسه",
"الجماليه",
"طريق النصر",
"الحي الثامن مدينة نصر",
"الوفاء والامل",
"كايرو فيستيفال",
"مدينة القاهرة الجديدة",
"طريق الشهيد",
"طريق بلبيس",
"الفسطاط",
"طره",
"حدائق حلوان",
"الحوامدية",
"سقاره",
"دهشور",
"الطريق الابيض",
"ابو رواش",
"العياط",
"الصف",
"اطفيح",
"طريق اسيوط القاهرة الصحراوي",
"كرداسه مدينة الجيزة",
"صفط اللبن",
"ارض اللواء",
"باسوس",
"عبود",
"بهتيم",
"الخصوص",
"عزبة النخل",
"ميدان ابن الحكم",
"ميدان الجامع مصر الجديدة",
"تريومف مصر الجديدة",
"الميرلاند مصر الجديدة",
"ميدان الحجاز مصر الجديدة",
"سفير مصر الجديدة",
"ميدان سفير مصر الجديدة",
"السبع عمارات مصر الجديدة",
"ميدان المحكمة مصر الجديدة",
"عمار بن ياسر مصر الجديدة",
"شارع عبدالعزيز فهمي مصر الجديدة",
"يوسف عباس",
"مصطفى النحاس مدينة نصر",
"ميدان روكسي مصر الجديدة",
"كوبري الحلميه",
"أحمد عصمت عين شمس",
"الف مسكن",
"محور المشير علي فهمي",
"اسكان الشباب",
"البنفسج",
"الهايكستب",
"شارع المقطم",

  // ---------------- الجيزة ----------------
"الجيزة",
"المهندسين",
"المريوطيه",
"الهرم",
"العجوزه",
"الوراق",
"امبابه",
"كرداسه",
"الدقي",
"ميدان الدقي",
"العمرانية",
"ترسا",
"الطالبيه",
"التعاون",
"المطبعة",
"زايد",
"اكتوبر",
"المحور",
"المهندسين مدينة الجيزة",
"حدائق الاهرام",
"فيصل",
"المريوطيه مدينة الجيزة",
"مشعل",
"حدائق اكتوبر",
"الهرم مدينة الجيزة",
"طريق الفيوم",
"طريق الواحات",
"٦ اكتوبر",
"العجوزه مدينة الجيزة",
"الزمالك",
"الوراق مدينة الجيزة",
"عابدين",
"شبرا",
"شبرا الخيمه",
"كورنيش النيل",
"روض الفرج",
"نيو جيزه",
"امبابه مدينة الجيزة",
"كرداسه مدينة الجيزة",
"الدقي مدينة الجيزة",
"ميدان الدقي مدينة الجيزة",
"العمرانية مدينة الجيزة",
"ترسا مدينة الجيزة",
"الطالبيه مدينة الجيزة",
"التعاون مدينة الجيزة",
"المطبعة مدينة الجيزة",
"الرماية",
"ميدان الرماية",
"البحر الأعظم",
"شارع مراد مدينة الجيزة",
"أرض اللواء",
"المنصورية",
"طريق المنصورية",
"مول مصر",
"هايبر وان",
"القرية الذكية",
"مدينة الشيخ زايد",
"beverly Hills",
"كمبوند زايد 2000",
"كمبوند جراند هايتس",
"كمبوند رويال سيتي",
"كمبوند ويست تاون",
"كمبوند الكرمة",
"كمبوند جاليريا مون فالي",
"كمبوند اليجريا",
"كمبوند سوديك ويست",
"كمبوند بيفرلي هيلز زايد",
"حدائق الشيخ زايد",
"ميدان لبنان مدينة الجيزة",
"شارع جامعة الدول العربية مدينة الجيزة",
"جامعة القاهرة",
"ميدان النهضة",
"شارع الهرم مدينة الجيزة",
"شارع فيصل مدينة الجيزة",
"ميدان الجيزة مدينة الجيزة",
"المنيب",
"ساقية مكي",
"كفر طهرمس",
"بولاق الدكرور مدينة الجيزة",
"صفط اللبن مدينة الجيزة",
"أبو رواش",
"الحوامدية",
"البدرشين",
"العياط",
"الصف",
"أطفيح",
"الواحات البحرية",

  // ---------------- الإسكندرية ----------------
"الإسكندرية",
"كوم الدكة",
"الشاطبي",
"الأنفوشي",
"رأس التين",
"بحري",
"المكس",
"القباري",
"كرموز",
"الورديان",
"الكورنيش",
"محطة الرمل",
"ميامي",
"العصافره",
"سموحه",
"ستانلي",
"جليم",
"زيزينيا",
"سيدي بشر",
"العجمي",
"الهانوفيل",
"أبو قير",
"المعمورة",
"برج العرب",
"المنتزه",
"سان ستيفانو",
"كامب شيزار",
"سبورتنج",
"سيدي جابر",
"رمل اول",
"رمل تاني",
"باكوس",
"غيط العنب",
"ميدان محطة مصر",
"ميدان المنشية",
"ميدان الساعة",
"جامعة الإسكندرية",
"قلعة قايتباي",
"مكتبة الإسكندرية",
"المعمورة البلد",
"المعمورة الشاطئ",
"كفر عبده",
"الابراهيمية",
"النزهة",
"بولكلي",
"فلمنج",
"جناكليس",
"لوران",
"رشدي",
"مدينة برج العرب الجديدة",
"العامرية",
"الهانوفيل البحرية",
"الحضرة",
"شدس",
"جليم باي",
"سيدي كرير",
"العلمين الجديدة",

  // ---------------- الدقهلية ----------------
"المنصورة",
"طلخا",
"ميت غمر",
"أجا",
"السنبلاوين",
"دكرنس",
"منية النصر",
"بلقاس",
"بني عبيد",
"جامعة المنصورة",
"كورنيش المنصورة",
"شارع الجيش",
"ميدان مشعل",
"ميدان أم كلثوم",

  // ---------------- الشرقية ----------------
"الزقازيق",
"العاشر من رمضان",
"بلبيس",
"أبو حماد",
"أبو كبير",
"ههيا",
"فاقوس",
"منيا القمح",
"كفر صقر",
"الإبراهيمية",
  // معالم
"جامعة الزقازيق",
"شارع الجلاء",
"ميدان التحرير الزقازيق",
"طريق بلبيس",

  // ---------------- الغربية ----------------
"طنطا",
"المحلة الكبرى",
"كفر الزيات",
"زفتى",
"السنطة",
"بسيون",
  // شوارع ومعالم
"جامعة طنطا",
"كورنيش طنطا",
"ميدان المحطة طنطا",
"شارع البحر طنطا",
  // ---------------- القليوبية ----------------
"شبرا الخيمة",
"بنها",
"قليوب",
"قها",
"طوخ",
"الخانكة",
"العبور",
"الخصوص",
"كفر شكر",
  // شوارع ومعالم
"جامعة بنها",
"كورنيش بنها",
"طريق القاهرة – الإسكندرية الزراعي",
"ميدان المؤسسة",
"شارع 15 مايو شبرا الخيمة",

  // ---------------- المنوفية ----------------
"شبين الكوم",
"منوف",
"مدينة السادات",
"سرس الليان",
"اشمون",
"الباجور",
"قويسنا",
"بركة السبع",
"تلا",
  // شوارع ومعالم
"جامعة المنوفية",
"كورنيش شبين الكوم",
"شارع الاستاد",
"ميدان شرف",

  // ---------------- كفر الشيخ ----------------
"كفر الشيخ",
"دسوق",
"بيلا",
"الحامول",
"بلطيم",
"قلين",
"فوه",
  // شوارع ومعالم
"جامعة كفر الشيخ",
"كورنيش دسوق",
"مصيف بلطيم",

  // ---------------- البحيرة ----------------
"دمنهور",
"كفر الدوار",
"إيتاي البارود",
"كوم حمادة",
"أبو حمص",
"رشيد",
"إدكو",
  // شوارع ومعالم
"جامعة دمنهور",
"كورنيش رشيد",
"ميدان الساعة دمنهور",

  // ---------------- دمياط ----------------
"دمياط",
"دمياط الجديدة",
"فارسكور",
"كفر سعد",
"الزرقا",
  // شوارع ومعالم
"ميناء دمياط",
"الأثاث دمياط",
"كورنيش دمياط",
"رأس البر",

  // ---------------- الإسماعيلية ----------------
"الإسماعيلية",
"فايد",
"القنطرة غرب",
"القنطرة شرق",
"أبو صوير",
"التل الكبير",
  // شوارع ومعالم
"جامعة الإسماعيلية",
"كورنيش القنطرة",
"ميدان الإسماعيلية",

  // ---------------- السويس ----------------
"السويس",
"الجناين",
"عتاقة",
"الأربعين",
"الأزرق",
"الأزرق الجديد",
  // شوارع ومعالم
"جامعة السويس",
"كورنيش السويس",
"ميدان السويس",

  // ---------------- بورسعيد ----------------
"بورسعيد",
"بورفؤاد",
"الزهور",
"الضواحي",
"العرب",
"الشرق",
"المناخ",
  // شوارع ومعالم
"جامعة بورسعيد",
"كورنيش بورسعيد",
"ميدان بورسعيد",

  // ---------------- الفيوم ----------------
"الفيوم",
"إطسا",
"سنورس",
"يوسف الصديق",
"طامية",
"أبشواي",
  // شوارع ومعالم
"جامعة الفيوم",
"كورنيش الفيوم",
"ميدان الفيوم",

  // ---------------- بني سويف ----------------
"بني سويف",
"الواسطي",
"ناصر",
"إهناسيا",
"الفشن",
"سمسطا",
"ببا",
  // شوارع ومعالم
"جامعة بني سويف",
"كورنيش بني سويف",
"ميدان بني سويف",

  // ---------------- المنيا ----------------
"المنيا",
"ملوي",
"أبو قرقاص",
"بني مزار",
"مغاغة",
"مطاي",
"دير مواس",
  // شوارع ومعالم
"جامعة المنيا",
"كورنيش ملوي",
"ميدان المنيا",

  // ---------------- أسيوط ----------------
"أسيوط",
"ديروط",
"منفلوط",
"القوصية",
"أبو تيج",
"صدفا",
"الغنايم",
  // شوارع ومعالم
"جامعة أسيوط",
"كورنيش أسيوط",
"ميدان أسيوط",

  // ---------------- سوهاج ----------------
"سوهاج",
"أخميم",
"جرجا",
"طهطا",
"دار السلام",
"المراغة",
"البلينا",
  // شوارع ومعالم
"جامعة سوهاج",
"كورنيش سوهاج",
"ميدان سوهاج",

  // ---------------- قنا ----------------
"قنا",
"نجع حمادي",
"دشنا",
"أبوتشت",
"قوص",
"الوقف",
  // شوارع ومعالم
"جامعة قنا",
"كورنيش قنا",
"ميدان قنا",

  // ---------------- الأقصر ----------------
"الأقصر",
"الكرنك",
"إسنا",
"أرمنت",
"نصر النوبة",

  // ---------------- أسوان ----------------
"أسوان",
"إدفو",
"كوم أمبو",
"دراو",
  // شوارع ومعالم
"جامعة أسوان",
"كورنيش أسوان",
"ميدان أسوان",

  // ---------------- البحر الأحمر ----------------
"الغردقة",
"سفاجا",
"القصير",
"مرسى علم",
"العلمين",
"العلمين الجديدة",

  // ---------------- جنوب سيناء ----------------
"شرم الشيخ",
"دهب",
"نويبع",
"طابا",
"العلمين",
"العلمين الجديدة",
  // شوارع ومعالم
"جامعة شرم الشيخ",
"كورنيش شرم الشيخ",
"ميدان شرم الشيخ",

  // ---------------- شمال سيناء ----------------
"العريش",
"الشيخ زويد",
"رفح",
"بئر العبد",
"العلمين",
"العلمين الجديدة",
  // شوارع ومعالم
"جامعة العريش",
"كورنيش العريش",
"ميدان العريش",

  // ---------------- مرسى مطروح ----------------
"مرسى مطروح",
"الضبعة",
"سيدي عبد الرحمن",
"رأس الحكمة",
"السلوم",
"سيدي براني",
  // شوارع ومعالم
"جامعة مرسى مطروح",
"كورنيش مرسى مطروح",
"ميدان مرسى مطروح",
"الشرقيه",
];

export const regionsByGovernorate = [
  {
    name:"القاهرة",
    areas: [
      // الأساس
"القاهرة",
"المقطم",
"مصر الجديده",
"العاشر من رمضان",
"بدر",
"عين شمس",
"جسر السويس",
"حلمية الزيتون",
"شيراتون مصر الجديدة",
"المطار",
"طريق الاسماعيليه",
"طريق السويس",
"الشروق",
"مدينتي",
"الرحاب",
"مدينه المستقبل",
"القطاميه",
"التجمع الخامس مدينة نصر",
"التجمع التالت",
"التجمع الاول مدينة نصر",
"شارع التسعين",
"طريق السخنه",
"الدائري",
"صلاح سالم",
"طريق الاوتوستراد مدينة المعادي",
"صقر قريش مدينة المعادي",
"المعادي",
"زهراء المعادي مدينة المعادي",
"غمره",
"احمد سعيد",
"الضاهر",
"باب الشعرية",
"الزاويه",
"السيده زينب",
"السيده عائشه",
"القلعه",
"مدينة نصر",
"مكرم عبيد مدينة نصر",
"عباس العقاد مدينة نصر",
"الحي السادس مدينة نصر",
"الحي السابع مدينة نصر",
"الحي العاشر",
"طريق المشير",
"محور جيهان السادات",
"محور محمد نجيب",
"جمال عبدالناصر",
"محور ٣٠ يونيو",
"الهضبه الوسطى",
"كورنيش المقطم",
"وسط البلد",
"حدائق القبة",
"الوايلي",
"الزيتون",
"المطرية",
"المرج",
"السلام",
"الخصوص",
"المطرية الجديدة",
"عين حلوان",
"حلوان",
"كوتسيكا",
"طرة",
"المعصرة",
"دار السلام",
"البساتين",
"منشية ناصر",
"العباسية",
"مدينة العباسية",
"حدائق الزيتون",
"الزهراء",
"مدينة الشروق",
"الهايكستب",
"الماظة",
"النزهة مصر الجديدة",
"النزهة الجديدة",
"هليوبوليس",
"سانت فاتيما مصر الجديدة",
"سانت فاتيما مصر الجديدة ميدان",
"روكسي مصر الجديدة",
"الكوربة",
"الميرغني مصر الجديدة",
"المطار القديم",
"أرض الجولف",
"الحلمية",
"سراي القبة",
"قصر القبة",
"منشية البكري",
"عين شمس الشرقية",
"عين شمس الغربية",
"شبرا",
"شبرا مصر",
"روض الفرج",
"الخليفة المأمون",
"كلية البنات مصر الجديدة",
"جامعة عين شمس",
"حدائق شبرا",
"الموسكي",
"العتبة",
"الأزبكية",
"رمسيس",
"محطة مصر",
"الفجالة",
"سكة الوايلي",
"التحرير",
"عبد المنعم رياض",
"طلعت حرب",
"قصر النيل",
"جاردن سيتي",
"ماسبيرو",
"كورنيش النيل",
"مدينة بدر",
"العاصمة الإدارية الجديدة",
"الأسمرات",
"مدينة 15 مايو",
"حلوان الجديدة",
"حدائق حلوان",
"وادي حوف",
"المعادي الجديدة مدينة المعادي",
"المعادي هايتس",
"جراند مول المعادي",
"مدينة الأمل",
"الزهراء المعادي مدينة المعادي",
"النصر سيتي سنتر",
"التجمع الثاني",
"التجمع الرابع",
"المستثمرين الشمالية",
"المستثمرين الجنوبية",

      // كمبوندات
"كمبوند القطامية هايتس",
"كمبوند ستون بارك",
"كمبوند ليان",
"كمبوند ميفيدا",
"كمبوند هايد بارك",
"كمبوند ماونتن فيو",
"كمبوند بالم هيلز القاهرة الجديدة",

      // شوارع رئيسية مشهورة
"شارع رمسيس",
"شارع 26 يوليو",
"شارع التحرير مدينة الجيزة",
"طلعت حرب",
"قصر العيني",
"المعز لدين الله الفاطمي",
"الحسين",
"الأزهر",
"شارع النصر مدينة نصر",
"شارع الطيران",
"شارع يوسف عباس",
"شارع مصطفى النحاس مدينة نصر",
"شارع حسن المأمون مدينة نصر",
"شارع الخليفة المأمون",
"شارع مصر والسودان",
"شارع شبرا",
"شارع الساحل",
"شارع بورسعيد",
"كورنيش المعادي مدينة المعادي",
"ميدان الجزائر مدينة المعادي",
"دجلة مدينة المعادي",
"كارفور المعادي مدينة المعادي",
"ثكنات المعادي مدينة المعادي",
"اوتوستراد المعادي مدينة المعادي",
"شارع ٧ مدينة المعادي",
"القمر الصناعي مدينة المعادي",
"كورنيش حلوان",
"شارع 9  مدينة المعادي",
"شارع 9 المعادي",
"شارع الجامعة الأمريكية",
"شارع التسعين الشمالي",
"شارع التسعين الجنوبي",
"شارع الثورة مصر الجديدة",
"شارع العروبة",
"شارع النزهة مصر الجديدة",
"شارع عثمان بن عفان",
"شارع بيروت",
"شارع بغداد",
"شارع هارون الرشيد مصر الجديدة",
"شارع الحجاز مصر الجديدة",
"شارع عمر بن الخطاب",
"شارع جسر السويس",
"المفارق",
"شارع ٩",
"شارع صبحي حسين",
"ميدان النافورة",
"ابتاون كايرو",
"كريم بنونه",
"شارع ١٧",
"الهضبه العليا",
"الهضبه السفلى",
"كوبري حسبالله الكفراوي",
"الاسمرات",
"محور كمال عامر",
"محور عمرو بن العاص",
"امتداد رمسيس",
"الدراسه",
"الجماليه",
"طريق النصر",
"الحي الثامن مدينة نصر",
"الوفاء والامل",
"كايرو فيستيفال",
"مدينة القاهرة الجديدة",
"طريق الشهيد",
"طريق بلبيس",
"الفسطاط",
"كورنيش المعادي مدينة المعادي",
"طره",
"حدائق حلوان",
"الحوامدية",
"سقاره",
"دهشور",
"الطريق الابيض",
"ابو رواش",
"العياط",
"الصف",
"اطفيح",
"طريق اسيوط القاهرة الصحراوي",
"كرداسه مدينة الجيزة",
"صفط اللبن مدينة الجيزة",
"ارض اللواء",
"باسوس",
"عبود",
"بهتيم",
"الخصوص",
"عزبة النخل",
"ميدان ابن الحكم",
"ميدان الجامع مصر الجديدة",
"يوسف عباس",
"مصطفى النحاس مدينة نصر",
"ميدان روكسي مصر الجديدة",
"كوبري الحلميه",
"أحمد عصمت عين شمس",
"الف مسكن",
"محور المشير علي فهمي",
"اسكان الشباب",
"البنفسج",
"الهايكستب",
"شارع المقطم",
    ],
  },

  {
    name:"الجيزة",
    areas: [
"الجيزة",
"المهندسين",
"المريوطيه",
"الهرم",
"العجوزه",
"الوراق",
"امبابه",
"كرداسه",
"الدقي",
"ميدان الدقي",
"العمرانية",
"ترسا",
"الطالبيه",
"التعاون",
"المطبعة",
"مدينة الجيزة",
"زايد",
"اكتوبر",
"المحور",
"المهندسين مدينة الجيزة",
"حدائق الاهرام",
"فيصل",
"المريوطيه مدينة الجيزة",
"مشعل",
"حدائق اكتوبر",
"الهرم مدينة الجيزة",
"طريق الفيوم",
"طريق الواحات",
"٦ اكتوبر",
"العجوزه مدينة الجيزة",
"الزمالك",
"الوراق مدينة الجيزة",
"عابدين",
"شبرا",
"شبرا الخيمه",
"كورنيش النيل",
"روض الفرج",
"نيو جيزه",
"امبابه مدينة الجيزة",
"كرداسه مدينة الجيزة",
"الدقي مدينة الجيزة",
"ميدان الدقي مدينة الجيزة",
"العمرانية مدينة الجيزة",
"ترسا مدينة الجيزة",
"الطالبيه مدينة الجيزة",
"التعاون مدينة الجيزة",
"المطبعة مدينة الجيزة",
"الرماية",
"ميدان الرماية",
"البحر الأعظم",
"شارع مراد مدينة الجيزة",
"أرض اللواء",
"المنصورية",
"طريق المنصورية",
"مول مصر",
"هايبر وان",
"القرية الذكية",
"مدينة الشيخ زايد",
"beverly Hills",
"كمبوند زايد 2000",
"كمبوند جراند هايتس",
"كمبوند رويال سيتي",
"كمبوند ويست تاون",
"كمبوند الكرمة",
"كمبوند جاليريا مون فالي",
"كمبوند اليجريا",
"كمبوند سوديك ويست",
"كمبوند بيفرلي هيلز زايد",
"حدائق الشيخ زايد",
"ميدان لبنان مدينة الجيزة",
"شارع جامعة الدول العربية مدينة الجيزة",
"جامعة القاهرة",
"ميدان النهضة",
"شارع الهرم مدينة الجيزة",
"شارع فيصل مدينة الجيزة",
"ميدان الجيزة مدينة الجيزة",
"المنيب",
"ساقية مكي",
"كفر طهرمس",
"نصر الدين مدينة الجيزة",
"خاتم المرسلين مدينة الجيزة",
"الحسن محمد مدينة الجيزة",
"اللبيني مدينة الجيزة",
"كفر طهرمس مدينة الجيزة",
"شارع العشرين مدينة الجيزة",
"البحر الأعظم مدينة الجيزة",
"شارع البحر الأعظم مدينة الجيزة",
"شارع وادي النيل مدينة الجيزة",
"ميدان سفنكس مدينة الجيزة",
"احمد عرابي مدينة الجيزة",
"البحوث مدينة الجيزة",
"القريه الفرعونية مدينة الجيزة",
"المنشيه مدينة الجيزة",
"الطوابق مدينة الجيزة",
"بولاق الدكرور مدينة الجيزة",
"صفط اللبن مدينة الجيزة",
"أبو رواش",
"الحوامدية",
"البدرشين",
"العياط",
"الصف",
"أطفيح",
"الواحات البحرية",
    ],
  },
  {
    name:"الإسكندرية",
    areas: [
"الإسكندرية",
"كوم الدكة",
"الشاطبي",
"الأنفوشي",
"رأس التين",
"بحري",
"المكس",
"القباري",
"كرموز",
"الورديان",
"الكورنيش",
"محطة الرمل",
"ميامي",
"العصافره",
"سموحه",
"ستانلي",
"جليم",
"زيزينيا",
"سيدي بشر",
"العجمي",
"الهانوفيل",
"أبو قير",
"المعمورة",
"برج العرب",
"المنتزه",
"سان ستيفانو",
"كامب شيزار",
"سبورتنج",
"سيدي جابر",
"رمل اول",
"رمل تاني",
"باكوس",
"غيط العنب",
"ميدان محطة مصر",
"ميدان المنشية",
"ميدان الساعة",
"جامعة الإسكندرية",
"قلعة قايتباي",
"مكتبة الإسكندرية",
"المعمورة البلد",
"المعمورة الشاطئ",
"كفر عبده",
"الابراهيمية",
"النزهة",
"بولكلي",
"فلمنج",
"جناكليس",
"لوران",
"رشدي",
"مدينة برج العرب الجديدة",
"العامرية",
"الهانوفيل البحرية",
"الحضرة",
"شدس",
"جليم باي",
"سيدي كرير",
"العلمين الجديدة",
    ],
  },
  {
    name:"القليوبية",
    areas: [
"شبرا الخيمة",
"بنها",
"قليوب",
"قها",
"طوخ",
"الخانكة",
"العبور",
"الخصوص",
"كفر شكر",
      // شوارع ومعالم
"جامعة بنها",
"كورنيش بنها",
"طريق القاهرة – الإسكندرية الزراعي",
"ميدان المؤسسة",
"شارع 15 مايو شبرا الخيمة",
    ],
  },
  {
    name:"بورسعيد",
    areas: [
"بورسعيد",
"بورفؤاد",
"طرح البحر",
"حي الكويت",
"القناة",
"السوق العمومي",
"الشاطئ",
"الكورنيش",
"ميناء بورسعيد",
      // معالم
"شارع محمد علي",
"ميدان الشهداء",
"تمثال ديليسبس",
"الاستاد الرياضي",
    ],
  },
  {
    name:"السويس",
    areas: [
"السويس",
"حي الأربعين",
"الجناين",
"فيصل",
"عتاقة",
      // معالم
"كورنيش السويس",
"ميدان الأربعين",
"ميدان اسماعيل عجمى",
"طريق السويس – القاهرة",
    ],
  },
  {
    name:"الدقهلية",
    areas: [
"المنصورة",
"طلخا",
"ميت غمر",
"أجا",
"السنبلاوين",
"دكرنس",
"منية النصر",
"بلقاس",
"بني عبيد",
"جامعة المنصورة",
"كورنيش المنصورة",
"شارع الجيش",
"ميدان مشعل",
"ميدان أم كلثوم",
    ],
  },
  {
    name:"الشرقية",
    areas: [
"الزقازيق",
"العاشر من رمضان",
"بلبيس",
"أبو حماد",
"أبو كبير",
"ههيا",
"فاقوس",
"منيا القمح",
"كفر صقر",
"الإبراهيمية",
      // معالم
"جامعة الزقازيق",
"شارع الجلاء",
"ميدان التحرير الزقازيق",
"طريق بلبيس",
    ],
  },
  {
    name:"الغربية",
    areas: [
"طنطا",
"المحلة الكبرى",
"كفر الزيات",
"زفتى",
"السنطة",
"بسيون",
      // شوارع ومعالم
"جامعة طنطا",
"كورنيش طنطا",
"ميدان المحطة طنطا",
"شارع البحر طنطا",
    ],
  },
  {
    name:"المنوفية",
    areas: [
"شبين الكوم",
"منوف",
"مدينة السادات",
"سرس الليان",
"اشمون",
"الباجور",
"قويسنا",
"بركة السبع",
"تلا",
      // شوارع ومعالم
"جامعة المنوفية",
"كورنيش شبين الكوم",
"شارع الاستاد",
"ميدان شرف",
    ],
  },
  {
    name:"البحيرة",
    areas: [
"دمنهور",
"كفر الدوار",
"إيتاي البارود",
"كوم حمادة",
"أبو حمص",
"رشيد",
"إدكو",
      // شوارع ومعالم
"جامعة دمنهور",
"كورنيش رشيد",
"ميدان الساعة دمنهور",
    ],
  },
  {
    name:"كفر الشيخ",
    areas: [
"كفر الشيخ",
"دسوق",
"بيلا",
"الحامول",
"بلطيم",
"قلين",
"فوه",
      // شوارع ومعالم
"جامعة كفر الشيخ",
"كورنيش دسوق",
"مصيف بلطيم",
    ],
  },
  {
    name:"دمياط",
    areas: [
"دمياط",
"دمياط الجديدة",
"فارسكور",
"كفر سعد",
"الزرقا",
      // شوارع ومعالم
"ميناء دمياط",
"الأثاث دمياط",
"كورنيش دمياط",
"رأس البر",
    ],
  },
  {
    name:"الإسماعيلية",
    areas: [
"الإسماعيلية",
"فايد",
"التل الكبير",
"أبو صوير",
"القنطرة شرق",
"القنطرة غرب",
      // معالم
"جامعة قناة السويس",
"كورنيش البحيرة",
"ميدان شامبليون",
    ],
  },
  {
    name:"الفيوم",
    areas: [
"الفيوم",
"إبشواي",
"إطسا",
"سنورس",
"طامية",
"يوسف الصديق",
      // معالم
"جامعة الفيوم",
"بحيرة قارون",
"قرية تونس السياحية",
    ],
  },
  {
    name:"بني سويف",
    areas: [
"بني سويف",
"مركز ناصر",
"مركز بوش",
"مركز العدوا",
"الفشن",
"ببا",
"سمسطا",
      // معالم
"جامعة بني سويف",
"كورنيش بني سويف",
"طريق الكريمات",
    ],
  },
  {
    name:"المنيا",
    areas: [
"المنيا",
"مغاغه",
"بني مزار",
"مطاي",
"سمالوط",
"ابو قرقاص",
"ملوي",
"دير مواس",
"العدوة",
      // معالم
"جامعة المنيا",
"كورنيش النيل المنيا",
"معبد بني حسن",
    ],
  },
  {
    name:"أسيوط",
    areas: [
"أسيوط",
"ديروط",
"القوصيه",
"ابنوب",
"منفلوط",
"الفتح",
"الغنايم",
"البداري",
"صدفا",
"ساحل سليم",
"ابوتيج",
      // معالم
"جامعة أسيوط",
"كورنيش أسيوط",
"ميدان الحرب والسلام",
    ],
  },
  {
    name:"سوهاج",
    areas: [
"سوهاج",
"اخميم",
"ساقلته",
"المراغة",
"طهطا",
"طما",
"جهينة الغربية",
"المنشأة",
"دار السلام",
"جرجا",
"البلينا",
      // معالم
"جامعة سوهاج",
"كورنيش سوهاج",
"معبد أبيدوس",
    ],
  },
  {
    name:"قنا",
    areas: [
"قنا",
"نجع حمادي",
"دشنا",
"قفط",
"نقادة",
"أبو تشت",
"فرشوط",
      // معالم
"جامعة جنوب الوادي",
"كورنيش قنا",
    ],
  },
  {
    name:"الأقصر",
    areas: [
"الأقصر",
"البر الغربي",
"الكرنك",
"الزينية",
"إسنا",
"أرمنت",
      // معالم
"معبد الكرنك",
"معبد الأقصر",
"وادي الملوك",
    ],
  },
  {
    name:"أسوان",
    areas: [
"أسوان",
"كوم امبو",
"إدفو",
"دراو",
"نصر النوبة",
      // معالم
"معبد فيلة",
"السد العالي",
"متحف النوبة",
    ],
  },
  {
    name:"البحر الأحمر",
    areas: [
"الغردقة",
"رأس غارب",
"سفاجا",
"القصير",
"مرسى علم",
"الشلاتين",
"حلايب",
      // معالم
"كورنيش الغردقة",
"الجونة",
"سهل حشيش",
"خليج مكادي",
    ],
  },
  {
    name:"الوادي الجديد",
    areas: [
"الخارجة",
"الداخلة",
"الفرافرة",
"الواحات البحرية",
"باريس",
      // معالم
"معبد هيبس",
"جبال الجلف الكبير",
    ],
  },
  {
    name:"مطروح",
    areas: [
"مرسى مطروح",
"الحمام",
"الضبعة",
"العلمين",
"سيدي عبد الرحمن",
"السلوم",
"سيوة",
      // معالم
"شاطئ عجيبة",
"شاطئ الغرام",
"وادي كلبوش",
"قلعة شالي سيوة",
    ],
  },
  {
    name:"شمال سيناء",
    areas: [
"العريش",
"الشيخ زويد",
"رفح",
"الحسنة",
"بئر العبد",
      // معالم
"جامعة العريش",
"كورنيش العريش",
    ],
  },
  {
    name:"جنوب سيناء",
    areas: [
"شرم الشيخ",
"دهب",
"نويبع",
"طابا",
"أبو رديس",
"أبو زنيمة",
"رأس سدر",
      // معالم
"خليج نعمة",
"هضبة أم سيد",
"محمية رأس محمد",
"محمية أبو جالوم",
    ],
  },
];
